/**
 * 计费比例设置
 */
import React from 'react';
import styles from './index.module.scss';
import { XOKButton, } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import RateModal from './modal/RateModal';
import model from '@/reducers/system/rate/model';
import { setBreadcrumbPaths } from '@/reducers/home/actions';



class RateList extends React.PureComponent {

    state = {
        currentOpenMode: '', // 当前需要打开的弹窗
        openModeParam: {}, // 当前需要打开的弹窗的入参
    }

    componentDidMount() {
        const { setBreadcrumbPaths, match } = this.props;
        setBreadcrumbPaths(match); // 自动识别面包屑
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, } = this.state;
        const { getRetaList, } = this.props;
        this.searchCache = {
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        getRetaList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 页面发生变化
    _paginationChange = (pageSize, pageNum) => {
        this.searchCache = { ...this.searchCache, pageSize, pageNum };
        this.props.getRetaList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageSize, pageNum }); // 【第5步：缓存分页状态】
    }
    // 表格操作  
    _tableAction = (item, type, value) => {
        const { history, } = this.props;
        switch (type) {
            case 'historical':
                history.push({
                    pathname: '/home/system/rate/historical/' + item,
                });
                break;
        }
    }

    // 新建设置项
    _create = () => {
        this.setState({
            currentOpenMode: 'creat'
        });
    }

    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case 'creat':
                return <RateModal title='新建计费比率设置' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    // 关闭弹框
    _closeMode = (status) => {
        this.setState({ currentOpenMode: '' });
        if (status) {
            this.props.getRetaList(this.searchCache);// 列表查询方法
        }
    }

    render() {
        const { retaList } = this.props;
        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <div className={styles.operate_box}>
                        <XOKButton style={{ width: 'auto' }} label='新建设置项' onClick={this._create} />
                    </div>
                    <TableContent
                        renderData={retaList}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

RateList.propTypes = {
    history: PropTypes.object, // 路由history对象
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息

    retaList: PropTypes.object,
    getRetaList: PropTypes.func,//列表数据(action)
};

const mapStateToProps = (state) => {
    return {
        retaList: state.rate.retaList,
    };
};
export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(RateList);
